var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTiktok(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#a4bff6",
    width: "24px",
    height: "24px",
    viewBox: "0 0 0.96 0.96",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tiktok") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.031c0.049 -0.001 0.098 0 0.147 -0.001a0.233 0.233 0 0 0 0.066 0.156l0 0A0.263 0.263 0 0 0 0.87 0.253l0.001 0v0.151a0.4 0.4 0 0 1 -0.16 -0.037l0.002 0.001a0.462 0.462 0 0 1 -0.062 -0.036l0.002 0.001c0 0.109 0 0.219 -0.001 0.328a0.285 0.285 0 0 1 -0.051 0.149l0.001 -0.001c-0.05 0.071 -0.13 0.118 -0.221 0.12h0a0.272 0.272 0 0 1 -0.154 -0.039l0.001 0.001C0.151 0.846 0.1 0.768 0.09 0.678l0 -0.001a0.695 0.695 0 0 1 0 -0.056c0.015 -0.143 0.135 -0.254 0.281 -0.254 0.016 0 0.032 0.001 0.048 0.004l-0.002 0c0.001 0.055 -0.002 0.111 -0.002 0.166a0.129 0.129 0 0 0 -0.164 0.079l0 0.001c-0.004 0.013 -0.006 0.028 -0.006 0.043 0 0.006 0 0.012 0.001 0.018l0 -0.001a0.128 0.128 0 0 0 0.131 0.108h0a0.126 0.126 0 0 0 0.104 -0.06l0 -0.001c0.008 -0.011 0.013 -0.025 0.015 -0.039l0 0c0.004 -0.067 0.002 -0.134 0.003 -0.201 0 -0.151 0 -0.302 0.001 -0.452z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.064ecef652d8628c0b756e2b3397d1a0.svg";
export { ForwardRef as ReactComponent };